import { createContext, useState, useEffect } from "react"
import { useNavigate } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'
import Axios from 'axios'
import Swal from 'sweetalert2'
import { useDispatch } from "react-redux"
export const AuthContext = createContext()

const getUsertypeFromRoles = (roles = []) => {
    if (roles.some(role => role.profileType === 'Superadmin')) {
        return 'superadmin'
    }

    if (roles.some(role => role.profileType === 'Club')) {
        return 'club'
    }

    return 'client'
}

export default function AuthProvider({children}) {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    let token = sessionStorage.getItem('jwt')

    const [clientauth, setClientauth] = useState()

    /**
     * Loguea un usuario y genera el token
     * @param {*} userCredentials
     */
    const loginClient = async (userCredentials) => {
        const options = {
            headers: { "Access-Control-Allow-Origin": "*" },
        }
        const result = await Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/login/in', { username: userCredentials.username, password: userCredentials.password }, options)
        if(result?.data?.message === 'notverified'){
            return {
                status: 'notverified',
                idUser: result?.data?.idUser
            }
        }

        sessionStorage.setItem('jwt', result.data['token'])
        token = sessionStorage.getItem('jwt')

        if (token && token !== 'undefined') {
            const decodedToken = jwtDecode(token)
            const usertype = getUsertypeFromRoles(decodedToken?.roles)

            setClientauth({ ...decodedToken, usertype })

            return {
                status: 'success',
                usertype
            }
        }

        // Mostramos el popup informativo
        // TODO: Traducir esto
        Swal.fire({
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            buttonsStyling: false,
            confirmButtonText: 'Cerrar',
            icon: 'error',
            text: 'Credenciales incorrectas'
        })

        return {
            status: 'invalid'
        }
    }

    // Desloguea un usuario eliminando token y seteando el usuario a null
    const logout = () => {
        setClientauth(null);
        dispatch({ type: 'USER_LOGOUT'})
        sessionStorage.removeItem('jwt')
        sessionStorage.removeItem('dataIncrono')
        navigate('/')
    }

    // Comprueba el estado del usuario y devuelve true o false
    const isLogged = () => !!clientauth;

    // Variables accesibles desde cualquier componente
    const contextValue = {clientauth, isLogged, loginClient, logout}

    /**
     * Usamos el useEffect para comprobar que el token no ha cambiado
     */
    // token = sessionStorage.getItem('jwt')
    useEffect(() =>{
        if (!token || token === 'undefined') {
            setClientauth(null)
            sessionStorage.removeItem('jwt')
            return
        }

        try {
            const decodedToken = jwtDecode(token)
            setClientauth({ ...decodedToken, usertype: getUsertypeFromRoles(decodedToken?.roles) })
        } catch (error) {
            setClientauth(null);
            sessionStorage.removeItem('jwt')
        }
    }, [token])

    return (
        <AuthContext.Provider value={contextValue}>
            {children}
        </AuthContext.Provider>
    )
}
